import {Box, Button, IconButton, Stack, TextField} from "@mui/material";
import {useState} from "react";
import {LiaBroomSolid} from "react-icons/lia";

const TenantProductsFilterBar = ({onSearch}) => {
  const [filterProductName, setFilterProductName] = useState("");
  const [filterInternalCode, setFilterInternalCode] = useState("");

  const buildParams = ({productName = filterProductName, internalCode = filterInternalCode} = {}) => {
    const params = {};
    if (productName) params.product_name = productName;
    if (internalCode) params.internal_code = internalCode;
    return params;
  };

  const handleSearch = () => onSearch(buildParams());

  const handleClear = () => {
    setFilterProductName("");
    setFilterInternalCode("");
    onSearch({});
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <Box sx={{mb: 2}}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <TextField
          label="Producto"
          size="small"
          value={filterProductName}
          onChange={(e) => setFilterProductName(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{width: 220}}
        />
        <TextField
          label="Código interno"
          size="small"
          value={filterInternalCode}
          onChange={(e) => setFilterInternalCode(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{width: 180}}
        />
        <Button variant="contained" size="small" onClick={handleSearch}>
          Aplicar
        </Button>
        <IconButton onClick={handleClear}>
          <LiaBroomSolid />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default TenantProductsFilterBar;
